"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
import { SearchPanelBody } from "./SearchPanelBody";
const DESKTOP_QUERY = "(min-width: 768px)";
export function SearchPanel() {
  const $ = _c(18);
  const open = useSearchPanelStore(_temp);
  const close = useSearchPanelStore(_temp2);
  const isDesktop = useMediaQuery(DESKTOP_QUERY);
  let t0;
  if ($[0] !== close) {
    t0 = function handleOpenChange(next) {
      if (!next) {
        close();
      }
    };
    $[0] = close;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleOpenChange = t0;
  if (isDesktop) {
    let t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <DialogTitle className="sr-only">Search</DialogTitle>;
      t2 = <DialogDescription className="sr-only">Search for products across the store.</DialogDescription>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t1 = $[2];
      t2 = $[3];
    }
    let t3;
    if ($[4] !== open) {
      t3 = <DialogContent data-testid="search-panel-desktop" showCloseButton={false} className="top-24 left-1/2 max-w-[calc(100%-2rem)] -translate-x-1/2 translate-y-0 gap-0 p-0 sm:max-w-2xl min-h-96">{t1}{t2}<SearchPanelBody autoFocus={open} /></DialogContent>;
      $[4] = open;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== handleOpenChange || $[7] !== open || $[8] !== t3) {
      t4 = <Dialog open={open} onOpenChange={handleOpenChange}>{t3}</Dialog>;
      $[6] = handleOpenChange;
      $[7] = open;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t1;
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SheetTitle className="sr-only">Search</SheetTitle>;
    t2 = <SheetDescription className="sr-only">Search for products across the store.</SheetDescription>;
    $[10] = t1;
    $[11] = t2;
  } else {
    t1 = $[10];
    t2 = $[11];
  }
  let t3;
  if ($[12] !== open) {
    t3 = <SheetContent side="top" data-testid="search-panel-mobile" showCloseButton={false} className="h-full gap-0 p-0">{t1}{t2}<SearchPanelBody autoFocus={open} /></SheetContent>;
    $[12] = open;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== handleOpenChange || $[15] !== open || $[16] !== t3) {
    t4 = <Sheet open={open} onOpenChange={handleOpenChange}>{t3}</Sheet>;
    $[14] = handleOpenChange;
    $[15] = open;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
function _temp2(state_0) {
  return state_0.close;
}
function _temp(state) {
  return state.open;
}